var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "15px",
    viewBox: "0 0 19 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pool-Memberlist",
    transform: "translate(-988.000000, -610.000000)",
    fill: "#14376f",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(130.000000, 392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(30.000000, 181.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(828.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-3",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6740714,-4.60724933e-14 L1.32577778,-4.60724933e-14 C0.971178968,-4.60724933e-14 0.639704365,0.137244841 0.388482143,0.388482143 C0.137256151,0.637499008 -1.60718e-14,0.971035714 -1.60718e-14,1.32359127 L-1.60718e-14,13.253631 C-1.60718e-14,13.9840377 0.595371032,14.5794087 1.32577778,14.5794087 L17.6740714,14.5794087 C18.4044782,14.5794087 18.9998492,13.9840377 18.9998492,13.253631 L18.9998492,1.32359127 C18.9998492,0.593184524 18.4044782,-4.60724933e-14 17.6740714,-4.60724933e-14 L17.6740714,-4.60724933e-14 Z M16.7367758,1.32355357 L9.49981151,8.56277976 L2.26284722,1.32355357 L16.7367758,1.32355357 Z M1.32566468,2.261 L6.35425595,7.28959127 L1.32566468,12.3181825 L1.32566468,2.261 Z M2.26296032,13.2557421 L7.29155159,8.22715079 L8.56462698,9.50022619 C8.81585298,9.75145218 9.14733135,9.88870833 9.50192262,9.88870833 C9.85651389,9.88870833 10.187996,9.75146349 10.4392183,9.50022619 L11.7122937,8.22715079 L16.7408849,13.2557421 L2.26296032,13.2557421 Z M12.6454802,7.28959127 L17.6740714,2.261 L17.6740714,12.3185595 L12.6454802,7.28959127 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.236378ef992f11b2cd66fa562791d014.svg";
export { ForwardRef as ReactComponent };